import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export const staticRouters = [{
        path: '/',
        name: 'index',
        component: resolve => require(["@/components/index"], resolve),
    }, {
        //目的地
        path: '/destination',
        name: 'destination',
        meta: {
            isIndexDes: true
        },
        component: resolve => require(["@/components/destination"], resolve),
    }, {
        //旅游攻略
        path: '/tourist',
        name: 'tourist',
        component: resolve => require(["@/components/tourist"], resolve),
    }, {
        //旅游指南
        path: '/touristGuide',
        name: 'touristGuide',
        component: resolve => require(["@/components/touristGuide"], resolve),
    }, {
        //活动社区
        path: '/activitiesCommunity',
        name: 'activitiesCommunity',
        component: resolve => require(["@/components/activitiesCommunity"], resolve),
    }, {
        //作品展示
        path: '/exhibition',
        name: 'exhibition',
        component: resolve => require(["@/components/exhibition"], resolve),
        meta: {   
            keepAlive: true
        }
    }, {
        //驿道商店
        path: '/store',
        name: 'store',
        component: resolve => require(["@/components/store"], resolve),
    }, {
        //驴友行记
        path: '/travel',
        name: 'travel',
        component: resolve => require(["@/components/travel"], resolve),
    }, {
        //驴友行记
        path: '/travelDetails',
        name: 'travelDetails',
        component: resolve => require(["@/components/travelDetails"], resolve),
    }, {
        //美图
        path: '/travelMito',
        name: 'travelMito',
        component: resolve => require(["@/components/travelMito"], resolve),
    }, {
        //美图详情
        path: '/travelMitoDetail',
        name: 'travelMitoDetail',
        component: resolve => require(["@/components/travelMitoDetail"], resolve),
    }, {
        //个人中心
        path: '/my',
        name: 'my',
        meta: {
            authorization: true
        },
        component: resolve => require(["@/components/my"], resolve),
    }, {
        //登录
        path: '/login',
        name: 'login',
        meta: {
            isLogin: true
        },
        component: resolve => require(["@/components/login"], resolve),
    }, {
        //注册
        path: '/register',
        name: 'register',
        component: resolve => require(["@/components/register"], resolve),
    }, {
        //驿声影详情
        path: '/soundDetail',
        name: 'soundDetail',
        component: resolve => require(["@/components/soundDetail"], resolve),
    }, {
        //交通
        path: '/traffic',
        name: 'traffic',
        meta: {
            isIndex: true
        },
        component: resolve => require(["@/components/traffic"], resolve),
    }, {
        //驿道名片
        path: '/postRoadCard',
        name: 'postRoadCard',
        component: resolve => require(["@/components/postRoadCard"], resolve),
    },
    {
        //驿声影
        path: '/sound',
        name: 'sound',
        component: resolve => require(["@/components/sound"], resolve),
    }, {
        //食宿推荐
        path: '/boardAndLodging',
        name: 'boardAndLodging',
        component: resolve => require(["@/components/boardAndLodging"], resolve),
    },
    {
        //主题推荐更多
        path: '/topicMore',
        name: 'topicMore',
        component: resolve => require(["@/components/topicMore"], resolve),
    },
    {
        //驿声影音乐更多
        path: '/soundMore',
        name: 'soundMore',
        component: resolve => require(["@/components/soundMore"], resolve),
    },
    {
        //驿道名片更多
        path: '/postRoadCardMore',
        name: 'postRoadCardMore',
        component: resolve => require(["@/components/postRoadCardMore"], resolve),
    },
    {
        //最新资讯更多
        path: '/informationMore',
        name: 'informationMore',
        component: resolve => require(["@/components/informationMore"], resolve),
    },
    {
        //解锁驿道更多
        path: '/unlockPostMore',
        name: 'unlockPostMore',
        component: resolve => require(["@/components/unlockPostMore"], resolve),
    },
    {
        //驿道游记更多
        path: '/postTravelMore',
        name: 'postTravelMore',
        component: resolve => require(["@/components/postTravelMore"], resolve),
    },
    {
        //图片集锦更多
        path: '/photoGalleryMore',
        name: 'photoGalleryMore',
        component: resolve => require(["@/components/photoGalleryMore"], resolve),
    },
    {
        //驿道游记更多
        path: '/travelPostMore',
        name: 'travelPostMore',
        component: resolve => require(["@/components/travelPostMore"], resolve),
    },
    {
        //驿道故事更多
        path: '/postStoryMore',
        name: 'postStoryMore',
        component: resolve => require(["@/components/postStoryMore"], resolve),
    },
    {
        //景点，美食，特产更多
        path: '/touristGuideMore',
        name: 'touristGuideMore',
        component: resolve => require(["@/components/touristGuideMore"], resolve),
    },
    {
        //搜索结果
        path: '/searchResult',
        name: 'searchResult',
        component: resolve => require(["@/components/searchResult"], resolve),
    },
    {
        //活动详情
        path: '/activiteDetail',
        name: 'activiteDetail',
        component: resolve => require(["@/components/activiteDetail"], resolve),
    },
    {
        //我要报名
        path: '/signUp',
        name: 'signUp',
        component: resolve => require(["@/components/signUp"], resolve),
    },
    {
        //文章详情
        path: '/articleDetail',
        name: 'articleDetail',
        component: resolve => require(["@/components/articleDetail"], resolve),
    },
    {
        //忘记密码
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: resolve => require(["@/components/forgetPassword"], resolve),
    },
    {
        //作品详情
        path: '/worksDetails',
        name: 'worksDetails',
        component: resolve => require(["@/components/worksDetails"], resolve),
    },
    {
        //视频更多
        path: '/videoMore',
        name: 'videoMore',
        component: resolve => require(["@/components/videoMore"], resolve),
    },
    {
        //视频详情
        path: '/videoDetail',
        name: 'videoDetail',
        component: resolve => require(["@/components/videoDetail"], resolve),
    },
    {
        //专辑列表
        path: '/albumList',
        name: 'albumList',
        component: resolve => require(["@/components/albumList"], resolve),
        meta: {   
            keepAlive: true
        }
    },
]
export default new Router({
    routes: staticRouters
})